import { Typography } from '@material-ui/core';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useOpenDocumentVerification from '@swf/core/hooks/useOpenDocumentVerification';
import { select } from '@swf/core/store';

import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Deposit_another_way,
  TXTWCL_For_further_helpX_contact_us_d_ELL,
  TXTWCL_ID_verification_required,
  TXTWCL_Upload_ID,
  TXTWCL_You_need_to_send_us_a_copy_of__ELL
} from './AuthenticationRequired.messages.json';

interface Props {
  onClose(): void;
}

const AuthenticationRequired: React.FC<Props> = ({ onClose }) => {
  const userId = useSelector(select.account.getUserId);
  const email = useSelector(select.account.getEmail);
  const locale = useSelector(select.locale.get);

  const openWindowContactSupport = useOpenDocumentVerification({
    resolverTag: ResolverTag.SwcSubmitDocumentsVerifications,
    query: { language: locale, userId, email },
    centered: true
  });

  return (
    <Prompt
      onClose={onClose}
      variant="default"
      title={{ translation: TXTWCL_ID_verification_required }}
      primaryButton={{ translation: TXTWCL_Upload_ID }}
      secondaryButton={{ translation: TXTWCL_Deposit_another_way }}
      onPrimaryButtonClick={openWindowContactSupport}
    >
      <Typography>
        <Translation {...TXTWCL_You_need_to_send_us_a_copy_of__ELL} />{' '}
        <Translation {...TXTWCL_For_further_helpX_contact_us_d_ELL} />
      </Typography>
    </Prompt>
  );
};

export default AuthenticationRequired;
